import { render, staticRenderFns } from "./ColleagueCategoryModalForm.vue?vue&type=template&id=54d37a0a"
import script from "./ColleagueCategoryModalForm.vue?vue&type=script&lang=js"
export * from "./ColleagueCategoryModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports